export default "__VITE_PUBLIC_ASSET__7f0dff4e__"